var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',{staticStyle:{"background":"white !important","min-height":"100vh"}},[_c('el-main',{staticClass:"index-main"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }